import React from "react";

import {
  Button,
  ButtonVariant,
} from "@patternfly/react-core";

import { AngleLeftIcon } from "@patternfly/react-icons";

import useNavigation from "../../hooks/useNavigation";

const SchoolMobileBackButton = () => {
  const { popView } = useNavigation();

  return (
    <Button
      variant={ButtonVariant.link}
      icon={<AngleLeftIcon />}
      onClick={popView}
    >
      Wróć
    </Button>
  );
};

export default SchoolMobileBackButton;